import { create } from 'zustand'
import type { ContextCardRef } from '@omni/shell-context'

// Shell-global UI state: the command palette and the peek drawer. Lives
// outside React trees because both are opened from surface code (via the
// per-surface OmniShellContext) and from bus events.
interface ShellUiState {
  paletteOpen: boolean
  setPaletteOpen: (open: boolean) => void
  peekRef: ContextCardRef | null
  openContextCard: (ref: ContextCardRef) => void
  closeContextCard: () => void
}

export const useShellStore = create<ShellUiState>((set) => ({
  paletteOpen: false,
  setPaletteOpen: (open) => set({ paletteOpen: open }),
  peekRef: null,
  openContextCard: (ref) => set({ peekRef: ref }),
  closeContextCard: () => set({ peekRef: null }),
}))
